import { useCallback, useState } from 'react';

/**
 * Job-level rows grouped under their booking (8986 / 8989 / 8990 / 8992). A
 * booking's service generates several jobs (1 job = 1 tug); the screens list
 * the booking once with its jobs beneath it. Groups keep the order in which
 * their first row arrives.
 */
export function groupByBooking(rows, keyOf = (r) => r.booking_id ?? r.booking_ref) {
  const groups = new Map();
  for (const row of rows) {
    const key = keyOf(row);
    if (!groups.has(key)) groups.set(key, { key, ref: row.booking_ref, first: row, rows: [] });
    groups.get(key).rows.push(row);
  }
  return [...groups.values()];
}

/** Which booking groups are collapsed; every group starts expanded. */
export function useCollapsedGroups() {
  const [collapsed, setCollapsed] = useState(() => new Set());
  const toggle = useCallback((key) => {
    setCollapsed((prev) => {
      const next = new Set(prev);
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  }, []);
  return [(key) => collapsed.has(key), toggle];
}
